<template>
  <base-layout>
    <template #sidebar>
      <ui-settings-sidebar />
    </template>
    <template #breadcrumbs>
      <ui-breadcrumbs
        :breadcrumbs="breadcrumbs"
        :title="title"
      />
    </template>
    <div class="bg-white shadow-sm p-3">
      <div class="mb-3 d-flex justify-content-between">
        <div>
          <ui-back-button :href="route('settings.dict_types.index')" />
          <span class="fw-bold ms-3">
            {{ item.title }}
          </span>
        </div>
        <ui-delete-button title="Удалить справочник" />
      </div>
      <ui-errors />
      <ul
        v-loading="loading"
        class="list-group mb-3 b-dict-items"
      >
        <li
          v-for="val in items"
          :key="val.id"
          class="list-group-item b-dict-items__item"
        >
          <div>
            <span class="me-4">
              {{ val.value }}
            </span>
            <el-popconfirm
              :title="`Удалить '${val.value}', вы уверены?`"
              confirm-button-text="Да"
              @confirm="deleteClick(val)"
            >
              <template #reference>
                <el-link
                  type="danger"
                  class="b-dict-items__delete"
                >
                  удалить
                </el-link>
              </template>
            </el-popconfirm>
          </div>
        </li>
      </ul>
      <el-button
        icon="el-icon-plus"
        type="primary"
        size="small"
        @click="addClick"
      >
        Добавить значение
      </el-button>
    </div>
  </base-layout>
</template>

<script>

import { ElMessageBox } from 'element-plus';
import BaseLayout from '@/Layouts/BaseLayout';
import UiBreadcrumbs from '@/components/Ui/UiBreadcrumbs';
import UiErrors from '@/components/Ui/UiErrors';
import UiDeleteButton from '@/components/Ui/UiDeleteButton';
import UiSettingsSidebar from '../Ui/UiSettingsSidebar';

export default {
  name: 'DictTypesShow',
  components: {
    UiSettingsSidebar,
    UiBreadcrumbs,
    BaseLayout,
    UiErrors,
    UiDeleteButton,
  },
  props: {
    item: { type: Object, required: true },
    errors: { type: Object, default: () => null },
  },
  data() {
    return {
      loading: false,
      breadcrumbs: [
        { title: 'Справочники', href: route('settings.dict_types.index') },
      ],
      form: this.$inertia.form({
        _method: 'post',
        name: this.item.name,
        title: this.item.title,
      }),
      rules: {
        name: [
          { required: true, message: 'Обязательное поле', trigger: 'blur' },
        ],
        title: [
          { required: true, message: 'Обязательное поле', trigger: 'blur' },
        ],
      },
    };
  },
  computed: {
    title() {
      return this.item.title;
    },
    items() {
      return this.item.values ?? [];
    },
  },
  methods: {
    addClick() {
      ElMessageBox.prompt('', 'Добавить значение', {
        confirmButtonText: 'Добавить',
        cancelButtonText: 'Отмена',
      }).then(({ value }) => {
        if (!value) {
          return;
        }
        this.loading = true;
        this.$inertia.post(route('settings.dict.store'), { dict_type_id: this.item.id, value }, {
          onFinish: () => {
            this.loading = false;
          },
        });
      });
    },
    deleteClick(item) {
      this.loading = true;
      this.$inertia.delete(route('settings.dict.destroy', item.id), {
        onFinish: () => {
          this.loading = false;
        },
      });
    },
  },
};
</script>
<style scoped lang="scss">
  .b-dict-items {

    &__item {
      &:nth-of-type(odd) {
        background-color: rgb(250, 250, 250);
      }

      &:hover {
        .b-dict-items__delete {
          visibility: visible;
        }
      }
    }

    &__delete {
      vertical-align: 2px;
      visibility: hidden;
    }
  }
</style>
